<p><img src="assets/loading.svg" class="loader" alt="Loading..." /></p>
